/**
 * Route definitions for the CertPerm (Certifications & Permits) module.
 * Lazily loads the main certifications and permits page with tabs.
 */
import createFeatureRoutes from '@/common/presentation/components/MainRouteHelper/MainRouteHelper';

const CertPermRoutes = createFeatureRoutes(
  'certperm',
  {
    main: () => import('../presentation/pages/CertPermPage')
  },
  [{ path: '', pageKey: 'main' }]
);

export default CertPermRoutes;
